<template>
		<div class="content home-page">
      <Header></Header>
			<div class="information2">
        <div class="" @click="back" style="margin-top:40px;margin-left:30px;width: 80px;height:80px;text-align: center;display: flex;align-items: center;justify-content: center;">
          <img width="50" src="../../static/images/back.png" />
        </div>
				<div class="faq-content" v-if="list!=''">
					<div class="">
						<p class="fs50 ac"><span>{{$t('TC')}}</span></p>
						<p class="mt30" v-html="list"></p>
					</div>
				</div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
export default {
    components:{
		Header
    },
    data() {
        return {
			list:''

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome()
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {
			  type:'2'
			}
			that.$api.post('/api/index/help',data,r =>{
				that.$parent.returnCode(r,function(){
					if(localStorage.getItem('lang')=='en'){
					  that.list = r.data.content
					}else{
					  that.list = r.data.mm_content
					}
					that.$parent.loadModal(false);
				});

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/termsAndCondition.vue